import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-help',
  templateUrl: './customer-help.component.html',
  styleUrls: ['./customer-help.component.css']
})
export class CustomerHelpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
